import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import Landing from "@/pages/Landing";
import Order from "@/pages/Order";
import Directory from "@/pages/Directory";
import Contest from "@/pages/Contest";
import EditionPage from "@/pages/EditionPage";
import CandidatePage from "@/pages/CandidatePage";
import PizzeriaDetail from "@/pages/PizzeriaDetail";
import Pizzagraphie from "@/pages/Pizzagraphie";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import PaymentResult from "@/pages/PaymentResult";
import Dashboard from "@/pages/dashboard/Dashboard";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen grid place-items-center font-display text-2xl cc-navy">Chargement…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function Shell({ children, footer = true }) {
  return (
    <div className="App flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-1">{children}</main>
      {footer && <Footer />}
    </div>
  );
}

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <AuthProvider>
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Shell><Landing /></Shell>} />
          <Route path="/commander" element={<Shell><Order /></Shell>} />
          <Route path="/annuaire" element={<Shell><Directory /></Shell>} />
          <Route path="/pizzeria/:id" element={<Shell><PizzeriaDetail /></Shell>} />
          <Route path="/concours" element={<Shell><Contest /></Shell>} />
          <Route path="/concours/:slug" element={<Shell><EditionPage /></Shell>} />
          <Route path="/pizzagraphie" element={<Shell><Pizzagraphie /></Shell>} />
          <Route path="/candidat/:slug" element={<Shell><CandidatePage /></Shell>} />
          <Route path="/login" element={<Shell footer={false}><Login /></Shell>} />
          <Route path="/register" element={<Shell footer={false}><Register /></Shell>} />
          <Route path="/payment/success" element={<Shell><PaymentResult /></Shell>} />
          <Route path="/payment/cancel" element={<Shell><PaymentResult /></Shell>} />
          <Route path="/dashboard" element={<Protected><Shell footer={false}><Dashboard /></Shell></Protected>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
